import { ExportTableDialog } from "@/ds";

import { CargaEstado } from "../components/carga-estado";
import { CargaLegend } from "../components/carga-legend";
import { CargaSubbar } from "../components/carga-subbar";
import { CargaToolbar } from "../components/carga-toolbar";
import { GanttObras } from "../components/gantt-obras";
import { GanttPrintChrome } from "../components/gantt-print-chrome";
import { GanttProfissionais } from "@/shared/components/gantt-profissionais";
import { IndicadoresDialog } from "@/shared/components/indicadores-dialog";
import { ResolverConflitoDialog } from "../components/resolver-conflito";
import type { CargaProfissionaisViewModel } from "./types-carga-profissionais";
import styles from "./carga-profissionais.module.scss";

/** Carga de Trabalho: perspectiva Profissionais (US-1779). */
export function CargaProfissionaisView({
  estado,
  capaImpressao,
  legendaImpressao,
  toolbar,
  chips,
  removerChip,
  legenda,
  ganttProfissionais,
  ganttObras,
  resolver,
  exportacao,
  indicadores,
}: CargaProfissionaisViewModel) {
  if (estado.status === "forbidden") return <CargaEstado {...estado} />;

  return (
    <div className={styles.container} data-testid="carga-de-trabalho-screen">
      <GanttPrintChrome {...capaImpressao} legend={<CargaLegend {...legendaImpressao} />} />
      <CargaToolbar {...toolbar} />
      <CargaSubbar chips={chips} onRemoverChip={removerChip}>
        <CargaLegend {...legenda} />
      </CargaSubbar>
      <CargaEstado {...estado} />

      {ganttProfissionais ? <GanttProfissionais {...ganttProfissionais} /> : null}
      {ganttObras ? <GanttObras {...ganttObras} /> : null}

      {resolver ? (
        <ResolverConflitoDialog
          canceladaVisivel={resolver.canceladaVisivel}
          profissional={resolver.row.profissional}
          conflitos={resolver.row.conflitos}
          carga={resolver.carga}
          periodo={resolver.periodo}
          today={resolver.today}
          onResolved={resolver.onResolved}
          onClose={resolver.onClose}
          simulacao={resolver.simulacao}
        />
      ) : null}

      {exportacao.aberta ? (
        <ExportTableDialog
          listName="carga de trabalho"
          isExporting={exportacao.exportando}
          onExport={exportacao.exportar}
          onCancel={exportacao.fechar}
        />
      ) : null}

      {indicadores.aberto ? (
        <IndicadoresDialog
          opcoes={indicadores.opcoes}
          value={indicadores.valor}
          onSave={indicadores.salvar}
          onCancel={indicadores.cancelar}
        />
      ) : null}
    </div>
  );
}
